import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';

const state = {
    computadoraDatos: [],
};

const mutations = {
    updateField,

    'INICIALIZAR_DATOS'(state) {
        state.computadoraDatos = [];
    },
    'SET_DATOS'(state, computadoraDatos) {
        state.computadoraDatos = computadoraDatos;
    },
};

const getters = {
    getField,
};

const actions = {
    getDatos ( { commit }, computadoraId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_DATOS');

            if (computadoraId != 0) {
                apiAxios.get(`bienes/computadoras/${computadoraId}`) 
                    .then(res => {
                        let datos = [
                            // { 'nombre': 'id', 'campo': 'Cod.', 'valor': res.data.id, 'formato': '' },
                            { 'nombre': 'codigo', 'campo': 'Cod.', 'valor': res.data.codigo, 'formato': '' },
                            { 'nombre': 'marcaModelo', 'campo': 'Marca/Modelo', 'valor': res.data.marcaModelo, 'formato': '' },
                            { 'nombre': 'numeroSerie', 'campo': 'Nro.Serie', 'valor': res.data.numeroSerie, 'formato': '' },
                            { 'nombre': 'caracteristicas', 'campo': 'Caracteristicas', 'valor': res.data.caracteristicas, 'formato': '' },
                            { 'nombre': 'rubro', 'campo': 'Rubro', 'valor': res.data.rubro, 'formato': '' },
                            { 'nombre': 'cotizacion', 'campo': 'Cotizacion', 'valor': res.data.cotizacion, 'formato': 'moneda' },
                            { 'nombre': 'pjeAmortizacion', 'campo': 'Pje.Amortizacion', 'valor': res.data.pjeAmortizacion, 'formato': 'porcentaje' },
                            { 'nombre': 'enRevision', 'campo': 'En Revisión', 'valor': res.data.enRevision? 'Si' : 'No', 'formato': '' }
                        ];

                        commit('SET_DATOS', datos);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
        })            
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}